export const SIDEBAR_WIDTH_PERCENT_CLASSES = Object.freeze({
  0: 'md:w-[0%]',
  1: 'md:w-[1%]',
  2: 'md:w-[2%]',
  3: 'md:w-[3%]',
  4: 'md:w-[4%]',
  5: 'md:w-[5%]',
  6: 'md:w-[6%]',
  7: 'md:w-[7%]',
  8: 'md:w-[8%]',
  9: 'md:w-[9%]',
  10: 'md:w-[10%]',
  11: 'md:w-[11%]',
  12: 'md:w-[12%]',
  13: 'md:w-[13%]',
  14: 'md:w-[14%]',
  15: 'md:w-[15%]',
  16: 'md:w-[16%]',
  17: 'md:w-[17%]',
  18: 'md:w-[18%]',
  19: 'md:w-[19%]',
  20: 'md:w-[20%]',
  21: 'md:w-[21%]',
  22: 'md:w-[22%]',
  23: 'md:w-[23%]',
  24: 'md:w-[24%]',
  25: 'md:w-[25%]',
  26: 'md:w-[26%]',
  27: 'md:w-[27%]',
  28: 'md:w-[28%]',
  29: 'md:w-[29%]',
  30: 'md:w-[30%]',
  31: 'md:w-[31%]',
  32: 'md:w-[32%]',
  33: 'md:w-[33%]',
  34: 'md:w-[34%]',
  35: 'md:w-[35%]',
  36: 'md:w-[36%]',
  37: 'md:w-[37%]',
  38: 'md:w-[38%]',
  39: 'md:w-[39%]',
  40: 'md:w-[40%]',
  41: 'md:w-[41%]',
  42: 'md:w-[42%]',
  43: 'md:w-[43%]',
  44: 'md:w-[44%]',
  45: 'md:w-[45%]',
  46: 'md:w-[46%]',
  47: 'md:w-[47%]',
  48: 'md:w-[48%]',
  49: 'md:w-[49%]',
  50: 'md:w-[50%]',
  51: 'md:w-[51%]',
  52: 'md:w-[52%]',
  53: 'md:w-[53%]',
  54: 'md:w-[54%]',
  55: 'md:w-[55%]',
  56: 'md:w-[56%]',
  57: 'md:w-[57%]',
  58: 'md:w-[58%]',
  59: 'md:w-[59%]',
  60: 'md:w-[60%]',
  61: 'md:w-[61%]',
  62: 'md:w-[62%]',
  63: 'md:w-[63%]',
  64: 'md:w-[64%]',
  65: 'md:w-[65%]',
  66: 'md:w-[66%]',
  67: 'md:w-[67%]',
  68: 'md:w-[68%]',
  69: 'md:w-[69%]',
  70: 'md:w-[70%]',
  71: 'md:w-[71%]',
  72: 'md:w-[72%]',
  73: 'md:w-[73%]',
  74: 'md:w-[74%]',
  75: 'md:w-[75%]',
  76: 'md:w-[76%]',
  77: 'md:w-[77%]',
  78: 'md:w-[78%]',
  79: 'md:w-[79%]',
  80: 'md:w-[80%]',
  81: 'md:w-[81%]',
  82: 'md:w-[82%]',
  83: 'md:w-[83%]',
  84: 'md:w-[84%]',
  85: 'md:w-[85%]',
  86: 'md:w-[86%]',
  87: 'md:w-[87%]',
  88: 'md:w-[88%]',
  89: 'md:w-[89%]',
  90: 'md:w-[90%]',
});

export const getSidebarWidthPercentClass = percent => {
  return (
    SIDEBAR_WIDTH_PERCENT_CLASSES[percent] || SIDEBAR_WIDTH_PERCENT_CLASSES[30]
  );
};
